(function () {
    Object.defineProperty(Array.prototype, '$distinct', {
        value: function (comparerFn, thisArg) {
            if (comparerFn == null) {
                comparerFn = (a, b) => Object.is(a, b);
            } else if (typeof comparerFn !== 'function') {
                throw new TypeError(comparerFn + ' is not a function');
            }

            return Array.prototype.reduce.call(Object(this), (acc, cur) => {
                if (!acc.some((e) => comparerFn.call(thisArg, cur, e))) {
                    acc.push(cur);
                }
                return acc;
            }, []);
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$distinctBy', {
        value: function (selector, thisArg) {
            if (selector == null)
                return [...new Set(this)];

            const O = Object(this);
            const len = O.length >>> 0;

            const map = new Map();
            for (let k = 0; k < len; k++) {
                const kVal = O[k];
                const kKey = typeof selector === 'function'
                    ? selector.call(thisArg, kVal, k, O)
                    : kVal?.[selector];

                if (!map.has(kKey))
                    map.set(kKey, kVal);
            }
            return [...map.values()];
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Array.prototype, '$fill', {
        value: function (valueFn, start, end) {
            if (typeof valueFn !== 'function') {
                throw new TypeError(valueFn + ' is not a function');
            }

            const O = Object(this);
            const len = O.length >>> 0;
            const relativeStart = start >> 0;
            const relativeEnd = end === undefined ? len : (end >> 0);

            let i, j;
            i = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);
            j = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);

            while (i < j) {
                O[i] = valueFn(i);
                i++;
            }

            return O;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _lastIndexOf = (array, predicateFn, thisArg) => {
        if (typeof predicateFn !== 'function') {
            throw new TypeError(predicateFn + ' is not a function');
        }

        const O = Object(array);
        const len = O.length >>> 0;

        let k = len - 1;
        while (k >= 0) {
            const kValue = O[k];
            if (predicateFn.call(thisArg, kValue, k, O)) {
                return k;
            }
            k--;
        }

        return -1;
    };

    Object.defineProperty(Array.prototype, '$findLast', {
        value: function (predicate, thisArg) {
            const lastIndex = _lastIndexOf(this, predicate, thisArg);
            if (lastIndex !== -1)
                return this[lastIndex];

            return undefined;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$findLastIndex', {
        value: function (predicate, thisArg) {
            return _lastIndexOf(this, predicate, thisArg);
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Array.prototype, '$groupBy', {
        value: function (selector, thisArg) {
            return Array.prototype.reduce.call(Object(this), (acc, cur, idx, src) => {
                const key = selector != null
                    ? typeof selector === 'function'
                        ? selector.call(thisArg, cur, idx, src)
                        : cur?.[selector]
                    : cur;

                if (acc[key]) {
                    acc[key].push(cur);
                } else {
                    acc[key] = [cur];
                }

                return acc;
            }, {});
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Array.prototype, '$groupByToMap', {
        value: function (selector, ...rest) {
            let comparerFn, thisArg;
            if (rest.length === 1) {
                if (typeof rest[0] === 'function') comparerFn = rest[0];
                else thisArg = rest[0];
            } else {
                comparerFn = rest[0];
                thisArg = rest[1];
            }

            return Array.prototype.reduce.call(Object(this), (acc, cur, idx, src) => {
                let key = selector != null
                    ? typeof selector === 'function'
                        ? selector.call(thisArg, cur, idx, src)
                        : cur?.[selector]
                    : cur;
                if (comparerFn) {
                    const keys = Array.from(acc.keys());
                    const keyIdx = keys.findIndex(e => comparerFn.call(thisArg, key, e));
                    if (keyIdx !== -1) {
                        key = keys[keyIdx];
                    }
                }

                const value = acc.get(key);
                if (value) {
                    value.push(cur);
                } else {
                    acc.set(key, [cur]);
                }

                return acc;
            }, new Map());
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Array.prototype, '$insertAt', {
        value: function (index, value) {
            Array.prototype.splice.call(this, index, 0, value);
            return this;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$removeAt', {
        value: function (index) {
            Array.prototype.splice.call(this, index, 1);
            return this;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _firstOrDefault = (array, comparerFn, thisArg, mode) => {
        const n = mode === 'asc' ? ((r) => r >= 0) : mode === 'desc' ? ((r) => r <= 0) : undefined;
        return Array.prototype.reduce.call(array, (pre, cur) => {
            const r = comparerFn.call(thisArg, pre, cur);
            return n(r) ? cur : pre;
        });
    };

    const _firstOrDefaultBy = (array, selector, thisArg, mode) => {
        const pairs = [];
        for (let k = 0, len = array.length >>> 0; k < len; k++) {
            const kVal = array[k];
            const kKey = selector != null
                ? typeof selector === 'function'
                    ? selector.call(thisArg, kVal, k, array)
                    : kVal?.[selector]
                : kVal;
            pairs.push([kKey, kVal]);
        }

        const comparerFn = (a, b) => (a[0] > b[0]) ? 1 : (a[0] < b[0]) ? -1 : 0;
        return _firstOrDefault(pairs, comparerFn, thisArg, mode)?.[1];
    };

    Object.defineProperty(Array.prototype, '$min', {
        value: function (comparerFn, thisArg) {
            if (comparerFn == null) {
                comparerFn = (a, b) => (a > b) ? 1 : (a < b) ? -1 : 0;
            } else if (typeof comparerFn !== 'function') {
                throw new TypeError(comparerFn + ' is not a function');
            }

            return _firstOrDefault(Object(this), comparerFn, thisArg, 'asc');
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$minBy', {
        value: function (selector, thisArg) {
            return _firstOrDefaultBy(Object(this), selector, thisArg, 'asc');
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$max', {
        value: function (comparerFn, thisArg) {
            if (comparerFn == null) {
                comparerFn = (a, b) => (a > b) ? 1 : (a < b) ? -1 : 0;
            } else if (typeof comparerFn !== 'function') {
                throw new TypeError(comparerFn + ' is not a function');
            }

            return _firstOrDefault(Object(this), comparerFn, thisArg, 'desc');
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$maxBy', {
        value: function (selector, thisArg) {
            return _firstOrDefaultBy(Object(this), selector, thisArg, 'desc');
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Array.prototype, '$shuffle', {
        value: function () {
            const O = Array.prototype.slice.call(this);
            const len = O.length >>> 0;

            let index = -1,
                tindex = len - 1;
            while (++index < len) {
                const rand = index + Math.floor(Math.random() * (tindex - index + 1));
                const value = O[rand];
                O[rand] = O[index];
                O[index] = value;
            }

            return O;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array, '$shuffle', {
        value: function (array) {
            return Array.prototype.$shuffle.call(array);
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _mergeSort = (array, comparerFn, thisArg, begin, end) => {
        const size = end - begin;
        if (size <= 1)
            return array;

        const middle = (end + begin) >> 1;
        _mergeSort(array, comparerFn, thisArg, begin, middle);
        _mergeSort(array, comparerFn, thisArg, middle, end);
        if (comparerFn.call(thisArg, array[middle - 1], array[middle]) <= 0)
            return array;

        let merged = [];
        let leftIndex = begin, rightIndex = middle;
        while (merged.length < size) {
            if (leftIndex === middle) {
                merged.push(array[rightIndex++]);
            } else if (rightIndex === end) {
                merged.push(array[leftIndex++]);
            } else {
                const c = comparerFn.call(thisArg, array[leftIndex], array[rightIndex]);
                if (c <= 0) {
                    merged.push(array[leftIndex++]);
                } else {
                    merged.push(array[rightIndex++]);
                }
            }
        }

        array.splice(begin, size, ...merged);
        return array;
    };

    const _mergeSortBy = (array, selector, thisArg, mode) => {
        const pairs = [];
        for (let k = 0, len = array.length >>> 0; k < len; k++) {
            const kVal = array[k];
            const kKey = selector != null
                ? typeof selector === 'function'
                    ? selector.call(thisArg, kVal, k, array)
                    : kVal?.[selector]
                : kVal;
            pairs.push([kKey, kVal]);
        }

        const t = (mode === 'asc') ? 1 : (mode === 'desc') ? -1 : undefined;
        const comparerFn = (a, b) => (a[0] > b[0]) ? t : (a[0] < b[0]) ? -t : 0;
        return _mergeSort(pairs, comparerFn, thisArg, 0, pairs.length).map((e) => e[1]);
    };

    Object.defineProperty(Array.prototype, '$sort', {
        value: function (comparerFn, thisArg) {
            if (comparerFn == null) {
                comparerFn = (a, b) => (a > b) ? 1 : (a < b) ? -1 : 0;
            } else if (typeof comparerFn !== 'function') {
                throw new TypeError(comparerFn + ' is not a function');
            }

            const O = Array.prototype.slice.call(Object(this));
            const len = O.length >>> 0;
            return _mergeSort(O, comparerFn, thisArg, 0, len);
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$sortAscBy', {
        value: function (selector, thisArg) {
            return _mergeSortBy(Object(this), selector, thisArg, 'asc');
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Array.prototype, '$sortDescBy', {
        value: function (selector, thisArg) {
            return _mergeSortBy(Object(this), selector, thisArg, 'desc');
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Boolean, '$from', {
        value: function (flag) {
            if (flag != null) {
                if (typeof flag === 'boolean') {
                    return flag;
                }

                if (typeof flag === 'string') {
                    return flag == 'TRUE' || flag == 'True' || flag == 'true' || flag == '1';
                }

                if (typeof flag === 'number') {
                    return !isNaN(flag) && flag != 0;
                }

                if (typeof flag === 'bigint') {
                    return flag != BigInt(0);
                }
            }

            return false;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _DAYS_TO_MONTH_366 = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366];
    const _DAYS_TO_MONTH_365 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];

    const _isLeapYear = (year) => {
        if (year % 1 !== 0) throw new TypeError();
        return year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
    };

    const _guardCheckType = (target, method) => {
        if (!(target instanceof Date)) {
            throw new TypeError('Illegal invocation');
        }
    };

    Object.defineProperty(Date.prototype, '$addMilliseconds', {
        value: function (milliseconds) {
            _guardCheckType(this, 'Date.prototype.$addMilliseconds');

            if (isNaN(milliseconds) || Number.isNaN(milliseconds)) {
                throw new TypeError(milliseconds + ' is not a number');
            }

            const date = new Date(this.getTime());
            date.setMilliseconds(this.getMilliseconds() + milliseconds);
            return date;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Date.prototype, '$addSeconds', {
        value: function (seconds) {
            _guardCheckType(this, 'Date.prototype.$addSeconds');
            return Date.prototype.$addMilliseconds.call(this, seconds * 1000);
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Date.prototype, '$addMinutes', {
        value: function (minutes) {
            _guardCheckType(this, 'Date.prototype.$addMinutes');
            return Date.prototype.$addSeconds.call(this, minutes * 60);
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Date.prototype, '$addHours', {
        value: function (hours) {
            _guardCheckType(this, 'Date.prototype.$addHours');
            return Date.prototype.$addMinutes.call(this, hours * 60);
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Date.prototype, '$addDays', {
        value: function (days) {
            _guardCheckType(this, 'Date.prototype.$addDays');
            return Date.prototype.$addHours.call(this, days * 24);
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Date.prototype, '$addMonths', {
        value: function (months) {
            _guardCheckType(this, 'Date.prototype.$addMonths');

            if (isNaN(months) || Number.isNaN(months)) {
                throw new TypeError(months + ' is not a number');
            } else if (months < -120000 || months > 120000) {
                throw new RangeError('The first argument must be between -120000 and 120000');
            }

            let y, m, d;
            y = this.getFullYear();
            m = this.getMonth() + 1 + +(+months).toFixed();
            d = this.getDate();

            let q = parseInt(m > 0 ? (m - 1) / 12 : m / 12 - 1);
            y += q;
            m -= q * 12;

            if (y < 1 || y > 9999) {
                throw new Error('The added or subtracted value results in an un-representable Date');
            }

            const map = _isLeapYear(y) ? _DAYS_TO_MONTH_366 : _DAYS_TO_MONTH_365;
            let days = map[m] - map[m - 1];
            if (d > days) d = days;

            const date = new Date(this.getTime());
            date.setDate(d);
            date.setMonth(m - 1);
            date.setFullYear(y);
            return date;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Date.prototype, '$addYears', {
        value: function (years) {
            _guardCheckType(this, 'Date.prototype.$addYears');

            if (isNaN(years) || Number.isNaN(years)) {
                throw new TypeError(years + ' is not a number');
            } else if (years < -10000 || years > 10000) {
                throw new RangeError('The first argument must be between -10000 and 10000');
            }

            let y = this.getFullYear();
            let m = this.getMonth();
            let d = this.getDate();

            if (_isLeapYear(y)) {
                if (d == 29 && m == 1) d--;
            }

            y = y + +(+years).toFixed();

            const date = new Date(this.getTime());
            date.setFullYear(y);
            date.setMonth(m);
            date.setDate(d);
            return date;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Date.prototype, '$format', {
        value: function (format = 'yyyy-MM-dd hh:mm:ss') {
            if (!(this instanceof Date)) {
                throw new TypeError('Illegal invocation');
            }

            const R = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'H+': this.getHours(),
                'h+': this.getHours(),
                'm+': this.getMinutes(),
                's+': this.getSeconds(),
                'q+': Math.floor((this.getMonth() + 3) / 3),
                'f': this.getMilliseconds()
            };
            if (/(y+)/.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
            }

            for (let k in R) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? R[k] : ('00' + R[k]).substring(('' + R[k]).length));
                }
            }

            return format;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Date.prototype, '$isToday', {
        value: function () {
            if (!(this instanceof Date)) {
                throw new TypeError('Illegal invocation');
            }

            const now = new Date();
            return this.getFullYear() === now.getFullYear() && this.getMonth() === now.getMonth() && this.getDate() === now.getDate();
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Date.prototype, '$isWeekend', {
        value: function () {
            if (!(this instanceof Date)) {
                throw new TypeError('Illegal invocation');
            }

            const r = this.getDay() % 7;
            return r === 0 || r === 6;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Date.prototype, '$midnight', {
        value: function () {
            if (!(this instanceof Date)) {
                throw new TypeError('Illegal invocation');
            }

            const date = new Date(this);
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
            return date;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Date, '$now', {
        value: function () {
            return new Date();
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Date, '$today', {
        value: function () {
            const date = new Date();
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Date, '$unix', {
        value: function (timestamp) {
            if (isNaN(timestamp) || Number.isNaN(timestamp)) {
                throw new TypeError(timestamp + ' is not a number');
            }

            const date = new Date();
            date.setTime(timestamp * 1000);
            return date;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Date.prototype, '$unix', {
        value: function () {
            if (!(this instanceof Date)) {
                throw new TypeError('Illegal invocation');
            }

            return parseInt(this.getTime() / 1000);
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Function, '$debounce', {
        value: function (fn, wait) {
            if (typeof fn !== 'function')
                throw new TypeError(fn + ' is not a function');

            if (isNaN(wait) || Number.isNaN(wait)) {
                throw new TypeError(wait + ' is not a number');
            } else if (+wait < 0) {
                throw new RangeError('The first argument must be greater than 0');
            }

            let timer = null;
            return function () {
                const ctx = this;
                const args = arguments;

                return new Promise((resolve) => {
                    if (!!timer) {
                        timer = clearTimeout(timer), null;
                    }

                    timer = setTimeout(function () {
                        resolve(fn.apply(ctx, args));
                    }, wait);
                });
            };
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Function, '$noop', {
        value: function () { /* noop */ },
        enumerable: false,
        configurable: false,
        writable: false
    });
})();

(function () {
    Object.defineProperty(Function, '$throttle', {
        value: function (fn, wait) {
            if (typeof fn !== 'function')
                throw new TypeError(fn + ' is not a function');

            if (isNaN(wait) || Number.isNaN(wait)) {
                throw new TypeError(wait + ' is not a number');
            } else if (+wait < 0) {
                throw new RangeError('The first argument must be greater than 0');
            }

            let timer = null,
                remaining = 0,
                previous = new Date();

            return function () {
                let now = new Date();
                remaining = now - previous;

                const ctx = this;
                const args = arguments;

                return new Promise((resolve) => {
                    if (remaining >= wait) {
                        previous = now;
                        resolve(fn.apply(ctx, args));
                    } else {
                        if (!!timer) {
                            timer = clearTimeout(timer), null;
                        }

                        timer = setTimeout(function () {
                            previous = new Date();
                            resolve(fn.apply(ctx, args));
                        }, wait - remaining);
                    }
                });
            };
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Number, '$isNumeric', {
        value: function (val) {
            if (typeof val === 'number') {
                // Discard Infinity and NaN
                return val - val === 0;
            }

            if (typeof val === 'string' && val.trim() !== '') {
                return Number.isFinite ? Number.isFinite(+val) : isFinite(+val);
            }

            return false;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _isNumber = (val) => {
        if (typeof val === 'number') {
            // Discard Infinity and NaN
            return val - val === 0;
        }

        if (typeof val === 'string' && val.trim() !== '') {
            return Number.isFinite ? Number.isFinite(+val) : isFinite(+val);
        }

        return false;
    };

    Object.defineProperty(Number, '$isOdd', {
        value: function (num) {
            if (!_isNumber(num)) {
                return false;
            }

            if (Number(num) !== Math.floor(num)) {
                return false;
            }

            return !!(~~num & 1);
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Number, '$isEven', {
        value: function (num) {
            if (!_isNumber(num)) {
                return false;
            }

            if (Number(num) !== Math.floor(num)) {
                return false;
            }

            return !(~~num & 1);
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Number.prototype, '$toFloor', {
        value: function (digits = 0) {
            if (!(digits >= 0 && digits <= 100)) {
                throw new RangeError('The first argument must be between 0 and 100');
            }

            let str = Math.floor(this * Math.pow(10, digits)) / Math.pow(10, digits) + '';
            if (digits > 0) {
                const intp = str.split('.')[0],
                    decp = str.split('.')[1] || '';
                if (decp.length < digits) {
                    str = intp + '.' + decp.padEnd(digits, '0');
                }
            }

            return Number.isNaN(+str) ? 'NaN' : str;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Number.prototype, '$toCeil', {
        value: function (digits = 0) {
            if (!(digits >= 0 && digits <= 100)) {
                throw new RangeError('The first argument must be between 0 and 100');
            }

            let str = Math.ceil(this * Math.pow(10, digits)) / Math.pow(10, digits) + '';
            if (digits > 0) {
                const intp = str.split('.')[0],
                    decp = str.split('.')[1] || '';
                if (decp.length < digits) {
                    str = intp + '.' + decp.padEnd(digits, '0');
                }
            }

            return Number.isNaN(+str) ? 'NaN' : str;
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Number.prototype, '$toRound', {
        value: function (digits = 0) {
            if (!(digits >= 0 && digits <= 100)) {
                throw new RangeError('The first argument must be between 0 and 100');
            }

            let str = Math.round(this * Math.pow(10, digits)) / Math.pow(10, digits) + '';
            if (digits > 0) {
                const intp = str.split('.')[0],
                    decp = str.split('.')[1] || '';
                if (decp.length < digits) {
                    str = intp + '.' + decp.padEnd(digits, '0');
                }
            }

            return Number.isNaN(+str) ? 'NaN' : str;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _isNaN = (obj) => {
        return Number.isNaN(obj);
    };

    const _isString = (obj) => {
        return typeof obj === 'string' || obj instanceof String;
    };

    const _isObject = (obj) => {
        return typeof obj === 'object' && obj !== null;
    };

    const _isArray = (obj) => {
        return Array.isArray(obj);
    };

    const _isSameType = (obj1, obj2) => {
        if (Object.prototype.toString.call(obj1) !== Object.prototype.toString.call(obj2)) {
            return false;
        }

        if (typeof obj1.constructor === 'function' && typeof obj2.constructor === 'function') {
            return obj1.constructor === obj2.constructor;
        }

        return true;
    };

    const _deepEquals = (obj1, obj2) => {
        if (obj1 === obj2) {
            return true;
        }

        if (_isNaN(obj1) && _isNaN(obj2)) {
            return true;
        }

        if (_isString(obj1) && _isString(obj2)) {
            return obj1.valueOf() === obj2.valueOf();
        }

        if (!_isObject(obj1) && !_isObject(obj2)) {
            return obj1 === obj2;
        }

        if (!_isSameType(obj1, obj2)) {
            return false;
        }

        if (_isArray(obj1) && _isArray(obj2)) {
            if (obj1.length !== obj2.length) {
                return false;
            }

            for (let i = 0, len = obj1.length; i < len; i++) {
                if (!_deepEquals(obj1[i], obj2[i])) {
                    return false;
                }
            }
        } else {
            const keys1 = [...Object.keys(obj1), ...Object.getOwnPropertySymbols(obj1)];
            const keys2 = [...Object.keys(obj2), ...Object.getOwnPropertySymbols(obj2)];
            if (!_deepEquals(keys1, keys2)) {
                return false;
            }

            for (let i = 0, len = keys1.length; i < len; i++) {
                if (!_deepEquals(obj1[keys1[i]], obj2[keys1[i]])) {
                    return false;
                }
            }
        }

        return true;
    };

    Object.defineProperty(Object, '$deepEquals', {
        value: function (obj1, obj2) {
            return _deepEquals(obj1, obj2);
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _isObjectLike = (value) => {
        const type = typeof value;
        return value !== null && (type === 'object' || type === 'function');
    };

    const _merge = (source1, source2) => {
        if (!_isObjectLike(source1) || !_isObjectLike(source2)) {
            return source2 === undefined ? source1 : source2;
        }

        return Object.keys({
            ...source1,
            ...source2
        }).reduce(
            (acc, key) => {
                acc[key] = _merge(source1[key], source2[key]);
                return acc;
            },
            Array.isArray(source1) ? [] : {}
        );
    };

    Object.defineProperty(Object, '$merge', {
        value: function (target, ...sources) {
            let result = target;

            for (let i = 0, len = sources.length; i < len; i++) {
                result = _merge(result, sources[i]);
            }

            return result;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Promise, '$delay', {
        value: function (wait = 0, result) {
            return new Promise((resolve) => {
                setTimeout(() => resolve(result), wait);
            });
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Promise, '$sequential', {
        value: function (promiseFns) {
            return new Promise((resolve, reject) => {
                let count = 0;
                let results = [];
                const iterateeFunc = (previousPromise, currentPromise) => {
                    return previousPromise
                        .then((res) => {
                            if (count++ !== 0) {
                                results = results.concat(res);
                            }
                            return currentPromise(res, results, count);
                        })
                        .catch((err) => {
                            return reject(err);
                        });
                };

                [...promiseFns, () => Promise.resolve()].reduce(iterateeFunc, Promise.resolve(false)).then(() => resolve(results));
            });
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Promise, '$try', {
        value: function (fn) {
            if (typeof fn !== 'function')
                return Promise.reject(new TypeError(fn + ' is not a function'));

            const ctx = this;
            const args = arguments;
            try {
                return Promise.resolve(fn.apply(ctx, args));
            } catch (err) {
                return Promise.reject(err);
            }
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(Promise, '$waitUntil', {
        value: function (keepWaiting, result, interval = 0) {
            return new Promise((resolve, reject) => {
                setTimeout(function fn () {
                    const p = keepWaiting();
                    if (typeof p?.then === 'function') {
                        p.then((t) => {
                            if (t) {
                                return resolve(result);
                            } else {
                                setTimeout(fn, interval);
                            }
                        }).catch((err) => {
                            reject(err);
                        });
                    } else if (p) {
                        return resolve(result);
                    } else {
                        setTimeout(fn, interval);
                    }
                });
            });
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(Promise, '$waitWhile', {
        value: function (keepWaiting, result, interval = 0) {
            return new Promise((resolve, reject) => {
                setTimeout(function fn () {
                    const p = keepWaiting();
                    if (typeof p?.then === 'function') {
                        p.then((t) => {
                            if (!t) {
                                return resolve(result);
                            } else {
                                setTimeout(fn, interval);
                            }
                        }).catch((err) => {
                            reject(err);
                        });
                    } else if (!p) {
                        return resolve(result);
                    } else {
                        setTimeout(fn, interval);
                    }
                });
            });
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    const _isString = (obj) => {
        return typeof obj === 'string' || obj instanceof String;
    };

    Object.defineProperty(String, '$equals', {
        value: function (str1, str2) {
            if (!_isString(str1) || !_isString(str2)) {
                return false;
            }

            return str1.valueOf() === str2.valueOf();
        },
        enumerable: false,
        configurable: false
    });

    Object.defineProperty(String, '$equalsIgnoreCase', {
        value: function (str1, str2) {
            if (!_isString(str1) || !_isString(str2)) {
                return false;
            }

            return str1.localeCompare(str2, undefined, { sensitivity: 'base' }) === 0;
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(String.prototype, '$reverse', {
        value: function () {
            return Array.from(this).reverse().join('');
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(String.prototype, '$toCamelCase', {
        value: function () {
            return String(this)
                .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
                .replace(/[^A-Za-z0-9]+/g, '$')
                .replace(/([a-z])([A-Z])/g, (_, a, b) => a + '$' + b)
                .toLowerCase()
                .replace(/(\$)(\w)/g, (_, a, b) => b.toUpperCase());
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(String.prototype, '$toKebabCase', {
        value: function () {
            return String(this)
                .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
                .replace(/([a-z])([A-Z])/g, (_, a, b) => a + '-' + b.toLowerCase())
                .replace(/[^A-Za-z0-9]+|_+/g, '-')
                .toLowerCase();
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(String.prototype, '$toPascalCase', {
        value: function () {
            return String(this)
                .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '$')
                .replace(/[^A-Za-z0-9]+/g, '$')
                .replace(/([a-z])([A-Z])/g, (_, a, b) => a + '$' + b)
                .toLowerCase()
                .replace(/(\$)(\w?)/g, (_, a, b) => b.toUpperCase());
        },
        enumerable: false,
        configurable: false
    });
})();

(function () {
    Object.defineProperty(String.prototype, '$toSnakeCase', {
        value: function () {
            return String(this)
                .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
                .replace(/([a-z])([A-Z])/g, (_, a, b) => a + '_' + b.toLowerCase())
                .replace(/[^A-Za-z0-9]+|_+/g, '_')
                .toLowerCase();
        },
        enumerable: false,
        configurable: false
    });
})();
